import { inject, provide } from 'vue';

import type { NTable } from '../interface';
import type { InjectionKey } from 'vue';

interface IResizeContextProps {
  onColumnResize: (columnKey: NTable.TKey, width: number) => void;
}

export const ResizeContextKey: InjectionKey<IResizeContextProps> = Symbol('cds:table:resize');

export const useProvideResize = (props: IResizeContextProps) => {
  provide(ResizeContextKey, props);
};

export const useInjectResize = () => {
  return inject(ResizeContextKey, {} as IResizeContextProps);
};
